import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { HotelBasicInfoWithLocation } from './-MyBrandHotel';
import { HImg, HLink, HBtn, HWysiwyg } from '~/components';

export interface DayTripThemeListProps {
  hotels: HotelBasicInfoWithLocation[];
}

export interface DayTripThemeListEmits {}

export interface DayTripThemeListScopedSlots {}

@Component<DayTripThemeListRef>({
  name: 'DayTripThemeList',
  render() {
    const { hotels, visibleHotels, hiddenHotels } = this;

    const hotelCountString = this.$t('value.numOfHotels', {
      count: hotels.length,
    }).toString();

    return (
      <div staticClass="my-hotels__list-wrapper__inner">
        <ul
          staticClass="my-hotels__list"
          class={{
            'my-hotels__list--less-than-4': hotels.length < 4,
            'my-hotels__list--less-than-2': hotels.length < 2,
          }}>
          {visibleHotels.map((hotel) => {
            const { location, brandAddress, introduction } = hotel;
            const imgUrl =
              introduction.image && introduction.image.derived.md.url;

            return (
              <li key={hotel.slug} staticClass="my-hotels__list__item">
                {!!imgUrl && (
                  <HImg
                    staticClass="my-hotels__list__item__thumbnail"
                    src={this.$res.img(imgUrl)}
                    alt={hotel.name}
                  />
                )}
                <p staticClass="my-hotels__list__item__address">
                  {brandAddress}
                </p>
                <HLink
                  staticClass="my-hotels__list__item__link"
                  to={location.to}
                  href={location.href}
                  target={location.target}
                  rel={location.rel}>
                  {hotel.name}
                </HLink>
              </li>
            );
          })}

          {hiddenHotels &&
            this.isActive &&
            hiddenHotels.map((hotel) => {
              const { location, brandAddress, introduction } = hotel;
              const imgUrl =
                introduction.image && introduction.image.derived.md.url;

              return (
                <li key={hotel.slug} staticClass="my-hotels__list__item">
                  {!!imgUrl && (
                    <HImg
                      staticClass="my-hotels__list__item__thumbnail"
                      src={this.$res.img(imgUrl)}
                      alt={hotel.name}
                    />
                  )}
                  <p staticClass="my-hotels__list__item__address">
                    {brandAddress}
                  </p>
                  <HLink
                    staticClass="my-hotels__list__item__link"
                    to={location.to}
                    href={location.href}
                    target={location.target}
                    rel={location.rel}>
                    {hotel.name}
                  </HLink>
                </li>
              );
            })}
        </ul>

        {this.existsHiddenHotels && !this.isActive && (
          <HBtn
            staticClass="my-hotels__list__daytrip__more my-hotels__list__daytrip__num-of-hotels"
            toggleIcon
            depressed
            block
            onClick={this.toggleIsActive}>
            <HWysiwyg value={hotelCountString} />
          </HBtn>
        )}

        {this.existsHiddenHotels && this.isActive && (
          <HBtn
            staticClass="my-hotels__list__daytrip__more my-hotels__list__daytrip__more--open"
            toggleIcon
            depressed
            block
            onClick={this.toggleIsActive}>
            {this.$i18n.t('label.footer.showLess')}
          </HBtn>
        )}
      </div>
    );
  },
})
export default class DayTripThemeListRef
  extends Vue
  implements DayTripThemeListProps {
  @Prop({ type: Array, required: true })
  readonly hotels!: HotelBasicInfoWithLocation[];

  /** もっと見るの開閉状態 */
  private isActive: boolean = false;

  /** 初期表示するホテル数 */
  private readonly INITIAL_VISIBLE_COUNT = 9;

  /** 初期表示するホテル */
  get visibleHotels(): HotelBasicInfoWithLocation[] {
    return this.hotels.slice(0, this.INITIAL_VISIBLE_COUNT);
  }

  /** 隠すホテル */
  get hiddenHotels(): HotelBasicInfoWithLocation[] {
    return this.hotels.slice(this.INITIAL_VISIBLE_COUNT);
  }

  /** 隠すホテルがあるかどうか */
  get existsHiddenHotels(): boolean {
    return this.hotels.length > this.INITIAL_VISIBLE_COUNT;
  }

  /** もっと見るの開閉状態をトグルする */
  toggleIsActive() {
    this.isActive = !this.isActive;
  }
}

export const DayTripThemeList = tsx
  .ofType<
    DayTripThemeListProps,
    DayTripThemeListEmits,
    DayTripThemeListScopedSlots
  >()
  .convert(DayTripThemeListRef);
